import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface SuvoHelpTextDialogData {
  title?: string;
  text: string;
  html?: boolean;
}

@Component({
  selector: 'suvo-help-text-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>{{ data.title || 'Info' }}</h2>

    <mat-dialog-content class="content">
      @if (data.html) {
        <div [innerHTML]="data.text"></div>
      } @else {
        {{ data.text }}
      }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
  styles: [
    `
      .content {
        white-space: pre-line;
      }
    `,
  ],
})
export class SuvoHelpTextDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public readonly data: SuvoHelpTextDialogData) {}
}
